import React from "react";
import ConfLeftPanel from "../login/authConf/confLeftPanel";
import RecoveryForm from "./Components/RecoveryForm";
import Favicon from "../../images/favicon.png";

const Recovery = () => {
  return (
    <div className="w-full min-h-screen  bg-[linear-gradient(to_top,_#38275B_0%,_#251A3C_33.33333333333333%,_#140E20_66.66666666666666%,_#000000_100%)]">
      <div className="py-4 border-b border-slate-700 flex items-center justify-between">
        <img src={Favicon} alt="R-Link" className="h-10 w-auto ml-3" />
        <div className="flex items-center gap-2 mr-4"></div>
      </div>
      <div className="flex justify-center h-[90vh] w-full pt-[1%]">
        <div className="sm:w-[90%] md:w-[80%] sm:rounded-2xl md:rounded-4xl overflow-hidden flex flex-col lg:flex-row">
          <ConfLeftPanel />
          <RecoveryForm />
        </div>
      </div>
    </div>
  );
};

export default Recovery;
